import { Injectable } from '@angular/core';
import {
  CanActivate, Router,
  ActivatedRouteSnapshot,
  RouterStateSnapshot
} from '@angular/router';
import { Location } from '@angular/common';
import { AccountApi } from '../sdk/services/custom';
import { AccessGroupService } from './accessgroup.service';
import { NotificationsService } from 'angular2-notifications';
import { LoopBackAuth } from '../sdk/services/core/auth.service';

@Injectable()
export class AuthGuard implements CanActivate {

  private currentuser: any;
  private accessGroupEntities: any = [];

  constructor(private _AccountApi: AccountApi, private router: Router,
    private accessGroupService: AccessGroupService, private _LoopBackAuth: LoopBackAuth,
    private _NotificationsService: NotificationsService, private location: Location) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    let url: string = state.url;
    this.currentuser = this._LoopBackAuth.getCurrentUserData();
    if (!this.currentuser || !this._AccountApi.isAuthenticated()) {
      this.resetValues();
    }

    if (this.doesThisUserHaveAccessToThisApp(this.currentuser)) {
      if (this.currentuser && !this.currentuser.role || this.currentuser.role == '' || null || undefined) {
        this.resetValues();
        this._NotificationsService.info('Message', 'Please ask admin to asign to any role.');
      } else if (this._AccountApi.isAuthenticated() && this.currentuser.role && this.currentuser.role == 'administrator') {
        return true;
      } else if (this._AccountApi.isAuthenticated() && this.currentuser.role && this.currentuser.role != 'administrator') {
        if (this.validateRoutes(url) == undefined) { return true; }
        return this.validateRoutes(url);
      }
    } else {
      this._NotificationsService.info("Message", "You do not have access to this application. Please contact admin team.");
      this.resetValues();
    }
  }

  public validateRoutes(url: any): boolean {
    if (this.accessGroupEntities && this.accessGroupEntities.length > 0) {
      if (!this.checkDoesThisRouteHaveAccess(url)) {
        this._NotificationsService.info("Message", "You do not have permission to view this page.");
      }
      return this.checkDoesThisRouteHaveAccess(url);
    } else {
      if (this.currentuser.role) {
        this.accessGroupService.getAccessGroupInfoForUser(this.currentuser)
          .then(accessgroup => {
            if (accessgroup && accessgroup.length > 0) {
              this.accessGroupEntities = accessgroup[0].entities;
              if (!this.checkDoesThisRouteHaveAccess(url)) {
                this._NotificationsService.info("Message", "You do not have permission to view this page.");
              }
              return this.checkDoesThisRouteHaveAccess(url);
            } else {
              this.resetValues();
              this._NotificationsService.info("Message", "You are not part of any AccessGroup. Please contact admin team.");
            }
          }).catch(error => {
            console.log('Error while getting access group entities', error);
            this.accessGroupEntities = [];
            return false;
          });
      } else {
        this._NotificationsService.info('Message', 'Please ask admin to asign to any role.');
      }
    }
  }

  private checkDoesThisRouteHaveAccess(url): boolean {
    if (url == '/home') return true;
    let entity = null;
    let localurl = null;
    let currententityurl = url.split("/").pop();
    let entityid = null;
    let uri_splits = url.split("/");
    if (uri_splits.length > 3) {
      entityid = uri_splits[2];
    }
    entity = this.accessGroupEntities.find(entity => ((entity.name == currententityurl) || (entity.id == currententityurl) || entityid == entity.id));
    if (!entity) {
      localurl = currententityurl == 'settings';
    }
    if (!entity && localurl) { return localurl };
    if (entity) {
      return entity.canview;
    }
    return false;
  }

  private doesThisUserHaveAccessToThisApp(user): boolean {
    let domain = null;
    if (user && user.role != 'administrator') {
      if (user.applications && user.applications.length > 0) {
        domain = user.applications.find(hostname => hostname == window.location.host);
        if (!domain) {
          domain = user.applications.find(hostname => 'localhost:4200' == window.location.host);
        }
        if (domain) return true;
        return false;
      } else {
        return false;
      }
    } else {
      return true;
    }
  }

  private getAccessGroupInfoForUser(user) {
    this.accessGroupService.getAccessGroupInfoForUser(this.currentuser || user)
      .then(accessgroup => {
        if (accessgroup && accessgroup.length > 0) {
          this.accessGroupEntities = accessgroup[0].entities;
        }
      }).catch(error => {
        console.error(error);
        this.accessGroupEntities = [];
      });
  }

  private resetValues() {
    this.currentuser = null;
    this.accessGroupEntities = [];
    this._AccountApi.logout();
    this.router.navigate(['/login']);
    return false;
  }

}


// WEBPACK FOOTER //
// ./src/app/shared/services/auth-guard.service.ts